import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import "./AuthenticatedLayout.css";

export default function AuthenticatedLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="layout-wrapper">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <main className={`main-content ${collapsed ? "collapsed" : ""}`}>
        {children}
      </main>
    </div>
  );
}
